/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {cashFrontendServiceGetHealth} from '../api'

export const useMutationCashFrontendServiceGetHealth = createReactQueryMutationHook('cashFrontendServiceGetHealth', cashFrontendServiceGetHealth)
